import { IoMdSave } from '@react-icons/all-files/io/IoMdSave'

const ButtonSaveDraft = ({
	type = 'button',
	title = 'Save Draft',
	onClick,
	...props
}) => {
	return (
		<button className="btn primary" type={type} onClick={onClick} {...props}>
			<IoMdSave />
			<span>{title}</span>
		</button>
	)
}

export default ButtonSaveDraft
